<template>
  <vame @update="update">
    <div class="note">
      <small>WASD or Arrow Keys to move.</small>
    </div>
    <keyboard-input
      :key-map="{
        curUp: [ 'w', 'arrowup' ],
        curDown: [ 's', 'arrowdown' ],
        curLeft: [ 'a', 'arrowleft' ],
        curRight: [ 'd', 'arrowright' ]
      }"
      @keydown="keydown"
    />
    <renderer
      :scale="3"
      :pixel-scale="6"
      :clear-color="'#fff'"
      :use-ecs="true"
      :ecs-render-components="renderComponents"
    >
    </renderer>
  </vame>
</template>

<script>
import { mapState } from 'vuex'
import { components, store } from '@/vame.js'
import VueLogo from './VueLogo.vue'
import VueLogoComponent from './VueLogo.js'

const { createStore, createEntity } = store
const { Render: RenderComponent } = store.components

export default {
  store: createStore(),

  components: {
    ...components
  },

  data () {
    return {
      entityUid: undefined
    }
  },

  computed: {
    ...mapState({
      entities: 'entities',
      components: 'components'
    }),

    renderComponents () {
      return {
        VueLogo
      }
    },

    playerComponent () {
      const { entityUid } = this
      if (!entityUid) return

      return this.components[entityUid].find((c) => c.kind === 'vue-logo')
    }
  },

  created () {
    this.$store.dispatch('resetState')
    this.createLogo()
  },

  methods: {
    createLogo () {
      const { dispatch, getters } = this.$store

      dispatch('addEntity', createEntity('vue-logo'))
      const entityUid = getters.lastEntityUid
      this.entityUid = entityUid

      let component = RenderComponent.create({ vueComponent: 'VueLogo' })
      dispatch('addComponent', { entityUid, component })

      component = VueLogoComponent.create({
        x: 160,
        y: 90
      })
      dispatch('addComponent', { entityUid, component })
    },

    keydown (button) {
      const { entityUid, playerComponent } = this

      const { speed, angularSpeed } = playerComponent

      if (button === 'curRight') {
        let angle = playerComponent.angle + angularSpeed
        if (angle > 360) angle = 360 - angle
        playerComponent.angle = angle
        this.$store.dispatch('setComponent', { entityUid, component: playerComponent })
      }
      else if (button === 'curLeft') {
        let angle = playerComponent.angle - angularSpeed
        if (angle < 0) angle = 360 + angle
        playerComponent.angle = angle
        this.$store.dispatch('setComponent', { entityUid, component: playerComponent })
      }

      const speedx = speed * Math.cos(playerComponent.angle * 0.0174533)
      const speedy = speed * Math.sin(playerComponent.angle * 0.0174533)

      if (button === 'curUp') {
        playerComponent.velx += speedx
        playerComponent.vely += speedy
        this.$store.dispatch('setComponent', { entityUid, component: playerComponent })
      }
      else if (button === 'curDown') {
        playerComponent.velx -= speedx
        playerComponent.vely -= speedy
        this.$store.dispatch('setComponent', { entityUid, component: playerComponent })
      }
    },

    update (delta) {
      const { playerComponent, entityUid } = this

      playerComponent.x += playerComponent.velx * delta
      playerComponent.y += playerComponent.vely * delta

      playerComponent.velx *= 0.9875 * delta
      playerComponent.vely *= 0.9875 * delta

      const cx = playerComponent.x
      if (cx < 0) playerComponent.x = 320 + cx
      else if (cx > 320) playerComponent.x = 0 - cx

      const cy = playerComponent.y
      if (cy < 0) playerComponent.y = 180 + cy
      else if (cy > 180) playerComponent.y = 0 - cy

      this.$store.dispatch('setComponent', { entityUid, component: playerComponent })
    }
  }
}
</script>

<style lang="sass">
body
  background: #fafafa
</style>
